import React, { useState } from 'react';
import Sidebar from '../../components/shared/Sidebar';
import Header from '../../components/shared/Header';
import MetricCard from '../../components/dashboard/MetricCard';
import StatusCard from '../../components/dashboard/StatusCard';
import RevenueChart from '../../components/dashboard/RevenueChart';
import OrderStatusChart from '../../components/dashboard/OrderStatusChart';
import './Dashboard.css';

const Dashboard: React.FC = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className="dashboard-container">
      <Sidebar 
        collapsed={sidebarCollapsed}
        onToggle={toggleSidebar}
      />
      <div className={`dashboard-main ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        <Header />
        <main className="dashboard-content">
          <div className="dashboard-header-section">
            <h1 className="dashboard-title">Dashboard</h1>
            <p className="dashboard-subtitle">
              Welcome back! Here's what's happening today.
            </p>
          </div>

          <div className="dashboard-metrics">
            <MetricCard
              title="Total Users"
              value="2,891"
              trend="15.3% vs last month"
              icon="👥"
              trendUp={true}
            />
            <MetricCard
              title="Total Restaurants"
              value="156"
              trend="8.2% 142 active"
              icon="🏢"
              trendUp={true}
            />
            <MetricCard
              title="Total Orders"
              value="1,234"
              trend="12.5% 42 pending"
              icon="📋"
              trendUp={true}
            />
            <MetricCard
              title="Total Revenue"
              value="$45,678"
              trend="18.4% vs last month"
              icon="💰"
              trendUp={true}
            />
            <MetricCard
              title="Active Deals"
              value="23"
              trend="5% 5 expiring soon"
              icon="💎"
              trendUp={true}
            />
            <MetricCard
              title="Pending Documents"
              value="8"
              icon="📑"
            />
          </div>

          <div className="dashboard-status">
            <StatusCard
              title="Pending Orders"
              value="42"
              icon="⏰"
              status="pending"
            />
            <StatusCard
              title="Completed Today"
              value="156"
              icon="✅"
              status="completed"
            />
            <StatusCard
              title="Active Reservations"
              value="18"
              icon="📈"
              status="active"
            />
            <StatusCard
              title="Failed Transactions"
              value="3"
              icon="❌"
              status="failed"
            />
          </div>

          <div className="dashboard-charts">
            <RevenueChart />
            <OrderStatusChart />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Dashboard;

